export const PUBLIC_PRESENTATION_NOT_AVAILABLE_ERROR = 'PresentationsStandardFriendlyError.DOCUMENT_TEMPORARILY_UNAVAILABLE';
export const PUBLIC_SHARED_LINK_NOT_FOUND = 'NOT_FOUND';
export const PUBLIC_SHARED_LINK_DOCUMENT_NOT_FOUND = 'DOCUMENT_NOT_FOUND';
export const PUBLIC_SHARED_LINK_EXPIRED = 'EXPIRED';
export const PUBLIC_SHARED_LINK_TEMPORARILY_UNAVAILABLE = 'DOCUMENT_TEMPORARILY_UNAVAILABLE';